import React from 'react'
import { DateRange } from 'react-day-picker'

import { Calendar } from '../../../../shadcn/components/ui/calendar'

interface ICalendarRangeProps {
  dateRange: DateRange | undefined
  setDateRange: (range: DateRange | undefined) => void
}

const CalendarRange = ({ dateRange, setDateRange }: ICalendarRangeProps) => {
  const handleDayClick = (
    newDateRange: DateRange | undefined,
    selectedDay: Date,
  ) => {
    if (newDateRange && dateRange?.from && dateRange?.to) {
      const fromUtcDate = new Date(
        Date.UTC(
          selectedDay.getFullYear(),
          selectedDay.getMonth(),
          selectedDay.getDate(),
        ),
      )
      setDateRange({ from: fromUtcDate, to: undefined })
    } else {
      const fromUtcDate = newDateRange?.from
        ? new Date(
            Date.UTC(
              newDateRange.from.getFullYear(),
              newDateRange.from.getMonth(),
              newDateRange.from.getDate(),
            ),
          )
        : undefined
      const toUtcDate = newDateRange?.to
        ? new Date(
            Date.UTC(
              newDateRange.to.getFullYear(),
              newDateRange.to.getMonth(),
              newDateRange.to.getDate(),
            ),
          )
        : undefined

      setDateRange({
        from: fromUtcDate,
        to: toUtcDate,
      })
    }
  }

  return (
    <Calendar
      mode='range'
      selected={dateRange}
      onSelect={handleDayClick}
      numberOfMonths={2}
    />
  )
}

export { CalendarRange }
